<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">Intent Session</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="3" class="mt-3">
              <v-text-field
                id="groupintentname-intentsession"
                :label="'Intent Group Name'"
                v-model="IntentSession.Name"
                :rules="[rules.required]"
                density="comfortable"
                variant="outlined"
                required
              >
                <template v-slot:append-outer>
                  <v-tooltip top max-width="300">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        size="x-small"
                        style="position: absolute; top: 0px; right: -6px"
                        v-bind="props"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("_InfoReplaceGroup") }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="3" style="size: 20" class="pa-2 d-flex align-center justify-start">
              <v-btn
                v-if="permissions.edit || permissions.add"
                id="button-savename-intentsession"
                color="primary"
                class="ml-2"
                variant="elevated"
                @click="SaveName()"
              >
                <v-icon size="20" style="padding-right: 5px"
                  >mdi-check-circle-outline</v-icon
                >{{ $t("save") }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="12" md="6">
              <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="6" class="pa-2">
                    <v-text-field
                      id="searchname-intentsession"
                      :label="'Intent Session Name'"
                      v-model="searchName"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-clipboard-text-search-outline"
                      hide-details
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="6"
                    class="pa-2 d-flex align-center justify-end"
                  >
                    <v-btn
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      @click="Search"
                    >
                      <v-icon start>mdi-magnify</v-icon>
                      Search
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" class="d-flex flex-wrap justify-end gap-2">
              <v-btn
                v-if="permissions.add"
                id="button-add-intentsession"
                color="primary"
                class="control-btn create-btn"
                variant="elevated"
                size="large"
                prepend-icon="mdi-plus-circle"
                rounded="xl"
                @click="Add()"
              >
                <span class="btn-text">{{ $t("add") }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          class="modern-table"
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :items="dataTable"
          :headers="headers"
          :loading="loadingTable"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: center">{{ item.number }}</td>
              <td>{{ item.name }}</td>
              <td style="text-align: center">{{ item.createBy }}</td>
              <td style="text-align: center">
                <div class="action-group" style="justify-content: center; max-width: 120px;">
                  <!-- Edit -->
                  <v-btn
                    :id="'button-edit-intentsession-' + item.number"
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    class="action-btn edit-btn"
                    icon
                    v-if="permissions.edit || permissions.view"
                  >
                    <v-icon size="18">{{ permissions.edit ? 'mdi-pencil-outline' : 'mdi-eye-outline' }}</v-icon>
                  </v-btn>
                  <!-- Custom Divider -->
                  <div v-if="permissions.edit && permissions.delete" class="action-divider"></div>

                  <!-- Delete -->
                  <v-btn
                    v-if="permissions.delete"
                    :id="'button-delete-intentsession-' + item.number"
                    variant="text"
                    density="comfortable"
                    @click="Delete(item.intentSessionID)"
                    class="action-btn delete-btn"
                    icon
                    :disabled="btnDisableDelete(item)"
                  >
                    <v-icon size="18">mdi-delete-outline</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
import checkPermissionTwo from "@/api/function.js";
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
export default {
  name: "IntentSession",
  inject: ["flagNav", "FontColorTitle","SubNavbarBackGround","Username", "RoleId"],
  components: {},
  mixins: [checkPermissionTwo],
  data: () => ({
    loadingTable: false,
    today: null,
    searchName: null,
    checkName: null,
    AddDataIntegration: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    dialog: false,
    files: [],
    uploadedFiles: [],
    DDDataType: [
      {
        id: "nvarchar",
        name: "nvarchar",
      },
      {
        id: "int",
        name: "int",
      },
      {
        id: "float",
        name: "float",
      },
      {
        id: "datetime",
        name: "datetime",
      },
      {
        id: "bit",
        name: "bit",
      },
    ],
    rules: {
      required: (value) => !!value || "Required.",
    },
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    sortBy: [],
    sortDesc: [],
    isFirst: true,
    isSearch: false,
    IntentSession: {
      IntentGroupID: null,
      Name: null,
    },
  }),
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('IntentGroup');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('IntentGroup'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('IntentGroup'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('IntentGroup'));
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('IntentGroup'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('IntentGroup'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('IntentGroup'),
      }
    },
    headers() {
      return [
        { title: this.$t("no"), align: "center", sortable: false },
        {
          title: "Intent Session Name",
          value: "Name",
          align: "center",
          sortable: true,
        },
        {
          title: "Create By",
          value: "CreateBy",
          align: "center",
          sortable: true,
        },
        { title: this.$t("action"), align: "center", sortable: false, width: "120px" },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    btnDisableDelete(item) {
      if (this.RoleId == 2 && item.createBy != this.Username) {
        return true;
      }
      return false;
    },
    Get() {
      let self = this;
      if(self.$route.query.id)
      {
        self.IntentSession.IntentGroupID = self.$route.query.id;
      }
      if (
        self.IntentSession.IntentGroupID == null ||
        self.IntentSession.IntentGroupID == undefined
      ) {
        return;
      }
      // self.dialog = true;
      self.loadingTable = true;
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        DataName: self.searchName,
        IntentGroupID: self.IntentSession.IntentGroupID,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableIntentSession(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
            self.IntentSession.Name = dataResponse.data.name;
            self.checkName = dataResponse.data.name;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          // self.dialog = false;
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Search() {
      let self = this;
      self.options.page = 1;
      self.Get();
    },
    Delete(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("ConfirmDeletion"),
            text: this.$t("confirmDeletionIntentSession"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteIntentSession(
                {
                  IntentSessionID: id,
                  IntentGroupID: self.IntentSession.IntentGroupID,
                },
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.Get();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource);
                }
              );
              self.Get();
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      if (this.IntentSession.Name != this.checkName) {
        this.$swal.fire({
          icon: "warning",
          title: this.$t("warning"),
          text: "Please fill in your Intent Group Name correctly",
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }
      let self = this;
      if (
        self.IntentSession.IntentGroupID == null ||
        self.IntentSession.IntentGroupID == "" ||
        self.IntentSession.IntentGroupID == undefined
      ) {
        self.CreateGroupName(true);
      } else {
        self.$router.push({
          name: "IntentSessionDetail",
          query: {
            idGroup: self.IntentSession.IntentGroupID,
          },
        });
      }
    },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: "IntentSessionDetail",
        query: {
          id: item.intentSessionID,
          idGroup: self.IntentSession.IntentGroupID,
        },
      });
    },
    CreateGroupName(flagNextPage) {
      let self = this;
      if (self.IntentSession.Name == "" || self.IntentSession.Name == null) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningFillIntentGroupName"),
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }
      self.dialog = true;
      let temp = {
        Name: self.IntentSession.Name.trim(),
      };
      self.$call.CreateIntentGroup(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$router.push({
              name: "IntentSession",
              query: {
                id: dataResponse.data,
              },
            });
            if (dataResponse.data == 0) {
              self.$swal.fire({
                icon: "warning",
                title: self.$t("warning"),
                text: dataResponse.data.message,
                showConfirmButton: false,
                timer: 1800,
              });
            } else if (flagNextPage) {
              self.$router.push({
                name: "IntentSessionDetail",
                query: {
                  idGroup: dataResponse.data,
                },
              });
            } else {
              self.IntentSession.IntentGroupID = dataResponse.data;
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
            this.checkName = this.IntentSession.Name
          }else if (dataResponse.status == 3) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: dataResponse.message,
              showConfirmButton: false,
              timer: 1800,
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          if (errorResource.status != 0) {
            console.error(errorResource);
          }
        }
      );
    },
    UpdateGroupName() {
      let self = this;
      if (
        self.IntentSession.IntentGroupID == "" ||
        self.IntentSession.IntentGroupID == null ||
        (self.IntentSession.Name == null && self.IntentSession.Name == "")
      ) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningFillIntentGroupName"),
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }
      self.dialog = true;
      let temp = {
        Name: self.IntentSession.Name.trim(),
        IntentGroupID: self.IntentSession.IntentGroupID,
      };
      self.$call.UpdateIntentGroup(temp, (dataResponse) => {
        if (dataResponse.status == 0) {
          self.$swal.fire({
            icon: "success",
            title: dataResponse.message,
            showConfirmButton: false,
            timer: 1500,
          });
          self.Get();
          this.checkName = this.IntentSession.Name
        }else if (dataResponse.status == 3) {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: dataResponse.message,
            showConfirmButton: false,
            timer: 1800,
          });
        }
        self.dialog = false;
      });
    },
    SaveName() {
      let self = this;
      if (
        self.IntentSession.IntentGroupID == "" ||
        self.IntentSession.IntentGroupID == null
      ) {
        self.CreateGroupName(false);
      } else {
        self.UpdateGroupName();
      }
    },
    convertDateToString(date, seperator = "/") {
      return dateUtils.getStringWithTimeFromDate(
        moment(date).toDate(),
        seperator
      );
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!
      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      this.today = dd + "/" + mm + "/" + yyyy;
    },
  },
  mounted() {
    let self = this;
    this.GetDate();
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.v-tooltip {
  background-color: #333;
  color: #fff;
}
.AddColumn:hover {
  background-color: #1976d2 !important;
  color: white !important;
}
:deep(.UploadFile .NoDragDrop button.v-btn) {
  margin: 0px !important;
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead) {
  position: sticky;
  top: 0;
  z-index: 2;
}

.modern-table :deep(.v-table__wrapper thead th) {
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
</style>
